import { useQuery, UseQueryResult } from 'react-query';
import type { ResponseFormat } from '../algebra/global';

import { Http } from '../prelude/http';

/**
 * Used to get existing Messages for Any OHL/TxHL
 * @param task_sid
 */

interface IFormResource {
  fields: any;
  field_specs: any;
}

export const useGetForm = (form_id: string): UseQueryResult<IFormResource> => {
  return useQuery(['form', form_id], () => Http.Request<ResponseFormat<IFormResource>>('GET', `/resources/api/v1/visitor/forms.get?document_id=${form_id}`).then((res) => res.data), {
    enabled: form_id !== null,
  });
};
